import {
    GET_TOKEN_DETAILS,
    GET_TOKEN_DETAILS_FAIL,
    GET_TOKEN_DETAILS_SUCCESS,
    GET_TOKEN_DETAILS_RESET,
} from "../action/getTokenDetailsAction";

import { api_err_msg } from "../strings.json";

const initialState = {
    apiState: "",
    list: [],
    message: "",
    pagination: {},
};

export default function (state = initialState, action) {
    console.log('action.type',action.type);
    switch (action.type) {
        case GET_TOKEN_DETAILS:
            return {
                ...state,
                apiState: "loading",
            };
            case GET_TOKEN_DETAILS_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            };
            case GET_TOKEN_DETAILS_SUCCESS:
            return {
                ...state,
                apiState: "sucess",
                list: action.response.data.data,
                pagination: action.response.data.data.pagination,
            };
            case GET_TOKEN_DETAILS_RESET:
            return initialState;
        default:
            return state;
    }
}